// Permission Checking Utility
import { state } from '../core/state.js';

export function hasPermission(permission) {
    try {
        if (!state.permissions || !Array.isArray(state.permissions)) {
            return false;
        }
        return state.permissions.includes(permission);
    } catch (error) {
        console.error('[Permissions] Error checking permission:', error);
        return false;
    }
}

export function hasAnyPermission(...permissions) {
    try {
        return permissions.some(p => hasPermission(p));
    } catch (error) {
        console.error('[Permissions] Error checking permissions:', error);
        return false;
    }
}

export function hasAllPermissions(...permissions) {
    try {
        return permissions.every(p => hasPermission(p));
    } catch (error) {
        console.error('[Permissions] Error checking permissions:', error);
        return false;
    }
}
